<template>
  <div class="alarm-linkage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div>
        <input-select selectTitle="设备类型" :selectKey="'deviceType'" selectWidth="220px" :selectData="deviceTypeList" @search="searchDeviceType" style="margin-right: 10px;"/>
<!--        <button-add @click="toAddPage" />-->
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @linkageConfig="linkageConfig" @changePagination="changePagination" @changeSwitch="changeSwitch" />

    <el-dialog title="报警配置" :visible.sync="alarmConfigDialogVisible" width="800px">
      <!-- 联动事件 -->
      <div class="form-tab-info-right" v-if="currentDeviceConfig.deviceCode">
        <el-tabs type="card" >
          <el-tab-pane label="消息通知">
            <div class="event-tab-message-main">
              <div class="message-person-line" v-for="person in currentDeviceConfig.alarmHandleManList" :key="person.personCode">
                <!-- 接警人 -->
                <el-checkbox v-model="person.checked" style="flex: 1;margin-right: 5px;">{{person.personName}}</el-checkbox>

                <div style="width: 300px;height: 19px;">
                  <!-- 通知类型 -->
                  <el-checkbox v-model="person.weChat" >微信通知</el-checkbox>
                  <el-checkbox v-model="person.message" >短信</el-checkbox>
                  <el-checkbox v-model="person.phone" >电话</el-checkbox>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="视频/抓图">
            <div class="event-tab-message-main">
              <div class="message-video-line" v-for="video in currentDeviceConfig.videoDeviceList" :key="video.deviceCode">
                <!-- 设备 -->
                <el-checkbox v-model="video.checked" style="flex: 1;margin-right: 5px;">{{video.deviceName}}</el-checkbox>

                <!-- 用途 -->
                <div style="width: 300px;height: 19px;">
                  <el-checkbox v-model="video.video" >视频</el-checkbox>
                  <el-checkbox v-model="video.screenShot" >抓图</el-checkbox>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="门禁">
            <div class="event-tab-message-main">
              <div class="message-access-line" v-for="access in currentDeviceConfig.accessDeviceList" :key="access.deviceCode">
                <!-- 门禁 -->
                <el-checkbox v-model="access.checked" style="width: 160px;margin-right: 5px;">{{access.deviceName}}</el-checkbox>

                <!-- 通知类型 -->
                <div style="width: 300px;height: 19px;">
                  <el-checkbox v-model="access.openDoor" >开门</el-checkbox>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="alarmConfigDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="setConfigAlarmAction" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/common/buttons/button-add";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Alarm";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import InputSelect from "../../../components/Input/InputSelect";

export default {
  components: {
    InputSelect,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "alarm-linkage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "报警中心",
          name: "alarm-device-manage"
        },
        {
          value: "报警联动"
        }
      ],
      searchPlaceholder: "设备名称",
      deleteTipInfo: "是否确认删除该接警人？",
      searchKey: "",
      deviceType: "",
      deviceTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "声光报警器",
          label: "声光报警器"
        },
        {
          key: "单输入模块",
          label: "单输入模块"
        },
        {
          key: "手动报警按钮",
          label: "手动报警按钮"
        },
        {
          key: "智能液晶显示盘",
          label: "智能液晶显示盘"
        },
        {
          key: "消火栓按钮",
          label: "消火栓按钮"
        },
        {
          key: "温感传感器",
          label: "温感传感器"
        },
        {
          key: "烟感传感器",
          label: "烟感传感器"
        },
        {
          key: "输出实模块",
          label: "输出实模块"
        },
        {
          key: "输出模块",
          label: "输出模块"
        },
        {
          key: "非编码探测器接口",
          label: "非编码探测器接口"
        },
        {
          key: "液位设备",
          label: "液位设备"
        },
        {
          key: "液压设备",
          label: "液压设备"
        }
      ],
      tableHead: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceType",
          label: "设备类型"
        },
        {
          prop: "ifEnable",
          label: "启用状态",
          active: "是",
          inactive: "否",
          isSwitch: true
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ["linkageConfig"],

      parentCode: "",
      typeList: [],

      alarmConfigDialogVisible: false,
      currentDeviceConfig: {
        deviceCode: ""
      },
      alarmHandleManList: [],
      videoDeviceList: [],
      accessDeviceList: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.init();
  },
  activated() {
    this.init();
    this.getPage();
  },
  methods: {
    init() {
      this.getAlarmHandleManList();
      this.getVideoDeviceList();
      this.getAccessDeviceList();
    },
    // 获取接警人员列表
    getAlarmHandleManList() {
      this.$axios
        .post(api.getAlarmHandleManList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              v.checked = false;
              v.weChat = false;
              v.message = false;
              v.phone = false;
            });
            this.alarmHandleManList = data;
          }
        })
        .catch(errorHandler("获取接警人员失败"));
    },
    // 获取视频设备列表
    getVideoDeviceList() {
      this.$axios
        .post(api.getVideoPassagewayList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              v.checked = false;
              v.video = false;
              v.screenShot = false;
            });
            this.videoDeviceList = data;
          }
        })
        .catch(errorHandler("获取视频设备列表失败"));
    },
    // 获取门禁设备列表
    getAccessDeviceList() {
      this.$axios
        .post(api.getAccessDeviceList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              v.checked = false;
              v.openDoor = false;
            });
            this.accessDeviceList = data;
          }
        })
        .catch(errorHandler("获取门禁设备列表失败"));
    },

    // 获取消防设备列表
    getFcsDeviceList() {
      this.$axios
        .post(`${api.getFcsDeviceList}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let resData = res.data.data;
            resData.map(v => {
              v.deviceTypeArr = v.deviceType.split(",");
              v.checkType = [];
              v.deviceTypeArr.map(type => {
                v[type] = {};
                v[type].typeChecked = false;
                v.linkageCode = this.linkageCode;
              });
            });
            this.fireControlDeviceList = resData;
            this.getSourceList();
          }
        })
        .catch(errorHandler("查询失败"));
    },

    // 获取联动配置信息
    linkageConfig(data) {
      this.$axios
        .get(`${api.getConfigAlarmAction}/${data.deviceCode}`, {})
        .then(res => {
          let data = res.data.data;
          this.alarmConfigDialogVisible = true;
          this.changeCurrentDeviceCode(data, data.deviceType);
        })
        .catch(errorHandler("获取联动配置信息失败"));

      // this.$router.push({
      //   path: `/alarm_linkage_config/${data.code}`
      // })
    },
    // 选择设备初始化配置
    changeCurrentDeviceCode(device) {
      let alarmHandleManListClone = this.deepClone(this.alarmHandleManList);
      let videoDeviceListClone = this.deepClone(this.videoDeviceList);
      let accessDeviceListClone = this.deepClone(this.accessDeviceList);
      let personList = [];
      let videoDeviceList = [];
      let guardDeviceList = [];
      if (device.personList) {
        alarmHandleManListClone.map(v => {
          let checkedState = false;
          let weChatState = false;
          let messageState = false;
          let phoneState = false;
          device.personList.map(person => {
            if (person.personCode === v.personCode) {
              checkedState = person.checked || true;
              weChatState = person.weChat;
              messageState = person.message;
              phoneState = person.phone;
            }
          });
          this.$set(v, "checked", checkedState);
          this.$set(v, "weChat", weChatState);
          this.$set(v, "message", messageState);
          this.$set(v, "phone", phoneState);
          personList.push(v);
        });
      }
      if (device.videoDeviceList) {
        videoDeviceListClone.map(v => {
          let checkedState = false;
          let videoState = false;
          let screenShotState = false;
          device.videoDeviceList.map(video => {
            if (video.deviceCode === v.deviceCode) {
              checkedState = video.checked || true;
              videoState = video.video;
              screenShotState = video.screenShot;
            }
          });
          this.$set(v, "checked", checkedState);
          this.$set(v, "video", videoState);
          this.$set(v, "screenShot", screenShotState);
          videoDeviceList.push(v);
        });
      }
      if (device.guardDeviceList) {
        accessDeviceListClone.map(v => {
          let checkedState = false;
          let openDoorState = false;
          device.guardDeviceList.map(guard => {
            if (guard.deviceCode === v.deviceCode) {
              checkedState = guard.checked || true;
              openDoorState = guard.openDoor;
            }
          });
          this.$set(v, "checked", checkedState);
          this.$set(v, "openDoor", openDoorState);
          guardDeviceList.push(v);
        });
      }
      let obj = {
        deviceCode: device.deviceCode,
        deviceName: device.deviceName,
        alarmHandleManList: personList,
        videoDeviceList: videoDeviceList,
        accessDeviceList: guardDeviceList
      };
      this.currentDeviceConfig = obj;
      console.log(obj);
    },

    // 修改设备联动配置
    setConfigAlarmAction() {
      let personListConfig = [];
      this.currentDeviceConfig.alarmHandleManList.map(v => {
        if (v.checked) {
          personListConfig.push(v);
        }
      });
      let videoDeviceListConfig = [];
      this.currentDeviceConfig.videoDeviceList.map(v => {
        if (v.checked) {
          videoDeviceListConfig.push(v);
        }
      });
      let guardDeviceListConfig = [];
      this.currentDeviceConfig.accessDeviceList.map(v => {
        if (v.checked) {
          guardDeviceListConfig.push(v);
        }
      });
      let reqData = {
        deviceCode: this.currentDeviceConfig.deviceCode,
        personList: personListConfig,
        videoDeviceList: videoDeviceListConfig,
        guardDeviceList: guardDeviceListConfig
      };
      this.$axios
        .post(api.setConfigAlarmAction, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("配置成功");
            this.alarmConfigDialogVisible = false;
            this.getPage();
          }
        })
        .catch(errorHandler("配置失败"));
    },

    toAddPage() {
      this.$router.push({
        name: "alarm-linkage-plan-add"
      });
    },
    searchDeviceType(v) {
      this.pageNum = 1;
      this.deviceType = v.value;
      this.getPage();
    },
    getPage() {
      this.$axios
        .post(api.getAlarmActionPage, {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          searchKey: this.searchKey,
          deviceType: this.deviceType
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    searchSelect(v) {
      this.pageNum = 1;
      this[v.key] = v.value;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    },

    changeSwitch(data) {
      this.$confirm("是否确认修改启用状态？", "提示")
        .then(() => {
          for (let i in data) {
            if (data[i] === "--") {
              data[i] = "";
            }
          }
          this.$axios
            .post(api.updateLinkage, data)
            .then(res => {
              nSuccess("修改成功");
              this.getPage();
            })
            .catch(errorHandler("修改失败"));
        })
        .catch(() => {
          this.getPage();
        });
    },
    // 修改
    goToModifyPage(code) {
      this.$router.push({
        path: `/alarm_linkage_plan_modify/${code}`
      });
    },

    // 深拷贝对象
    deepClone(obj) {
      var o;
      // 如果  他是对象object的话  , 因为null,object,array  也是'object';
      if (typeof obj === "object") {
        // 如果  他是空的话
        if (obj === null) {
          o = null;
        } else {
          // 如果  他是数组arr的话
          if (obj instanceof Array) {
            o = [];
            for (let i = 0, len = obj.length; i < len; i++) {
              o.push(this.deepClone(obj[i]));
            }
          }
          // 如果  他是对象object的话
          else {
            o = {};
            for (let j in obj) {
              o[j] = this.deepClone(obj[j]);
            }
          }
        }
      } else {
        o = obj;
      }
      return o;
    }
  }
};
</script>

<style scoped lang="less">
.alarm-linkage {
  .form-tab-info-right {
    margin-bottom: 40px;
    padding: 10px 0;
    flex: 1;
    background-color: #ffffff;
    .event-tab-message-main {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      max-height: 340px;
      overflow-y: auto;
      /* 消息通知 */
      .message-person-line {
        text-align: left;
        padding: 10px 20px;
        display: flex;
        justify-content: flex-start;
      }
      /* 视频抓图 */
      .message-video-line {
        text-align: left;
        padding: 10px 20px;
        display: flex;
        justify-content: flex-start;
      }
      /* 门禁 */
      .message-access-line {
        text-align: left;
        padding: 10px 20px;
        display: flex;
        justify-content: flex-start;
      }
    }
  }
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/AlarmManage/AlarmLinkage/AlarmLinkage.vue